import SettingsPanel from './settings-panel';
import VisibilityPanel from './visibility-panel';
import app from '../../public-api';

const loader = {
  name: 'us:settings:visibility-panel',

  extends: 'uScope',

  dependencies: ['us:user-config'],

  factory (uScope, userConfig) {
    const settingsPanel = new SettingsPanel(uScope, userConfig);

    return new VisibilityPanel(uScope, userConfig, settingsPanel);
  }
};

app.plugins.register(loader);



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/settings-services/settings-service-loader.js